import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchContacts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/contacts/get-all', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchContact(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/contacts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addContact(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/contacts/add', { ...userData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editContact(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/contacts/edit', { ...userData })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error.response))
      })
    },
  },
}
